import {
  LOCATIONS_LOADING,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  RESET_LOCATIONS
} from "../actions/types/locations";

const initialState = {
  data: [],
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: [...action.payload.data]
      };
    }

    case GET_LOCATIONS_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case RESET_LOCATIONS: {
      return {
        ...state,
        ...initialState
      };
    }

    case "RESET_MAP_REDUCER": {
      return {
        ...state,
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
};
